import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { OauthService } from '../../../../pages/login/data-access/services/oauth.service';

interface MenuItem {
  label: string;
  route: string;
  icon: string;
  onlyAdmin?: boolean;
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.component.html',
  styles: []
})
export class SidebarComponent implements OnInit {
  private oauthService = inject(OauthService);
  private router = inject(Router);

  menuItems: MenuItem[] = [
    {
      label: 'Usuarios',
      route: '/users',
      icon: '👥'
    },
    {
      label: 'Tipos de agente',
      route: '/agent-types',
      icon: '🏷️',
      onlyAdmin: true
    },
    {
      label: 'Documentación de referencia',
      route: '/documentation',
      icon: '📚'
    },
    {
      label: 'Agentes en Producción',
      route: '/agents',
      icon: '🎧'
    },
    {
      label: 'Mejora de Prompts',
      route: '/improve-prompt-manual',
      icon: '📝'
    },
    {
      label: 'Chatbot',
      route: '/chatbot-test',
      icon: '🤖',
    },
  ];

  userAdmin: boolean = false;
  userChatbot: boolean = false;

  ngOnInit() {
    // Añadir Tipos de agente al menú si el usuario es admin
    // Aquí podrías verificar el rol del usuario y modificar el menúItems en consecuencia
    this.oauthService.getCurrentUser().subscribe({
      next: (user) => {
        this.userAdmin = user.roles.some((role: any) => role.name === 'admin');
        this.userChatbot = user.email === 'csanchez@sdi.es' || user.email === 'omonsalvo@sdi.es';
      }
    });
  }

  onLogout(): void {
    this.oauthService.logout().subscribe({
      next: () => {
        this.router.navigate(['/login']);
      },
      error: () => {
        this.oauthService.clearToken();
        this.router.navigate(['/login']);
      }
    });
  }
}
